import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '@heroui/react';

interface RenameModalProps {
    isOpen: boolean;
    value: string;
    label?: string;
    title?: string;
    confirmText?: string;
    cancelText?: string;
    onChange: (value: string) => void;
    onClose: () => void;
    onConfirm: () => void;
    maxLength?: number;
}

export const RenameModal = ({
    isOpen,
    value,
    label = 'New Name',
    title = 'Rename',
    confirmText = 'Rename',
    cancelText = 'Cancel',
    onChange,
    onClose,
    onConfirm,
    maxLength = 250,
}: RenameModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>
                <Input
                    autoFocus
                    label={label}
                    maxLength={maxLength}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') onConfirm();
                    }}
                />
            </ModalBody>
            <ModalFooter>
                <Button variant="flat" onPress={onClose}>
                    {cancelText}
                </Button>
                <Button color="primary" onPress={onConfirm}>
                    {confirmText}
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
);
